import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  icon?: BoxIcon;
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon: Icon,
  className = '',
  fullWidth = false,
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer';
  const variants = {
    primary: 'bg-[#4338CA] text-white hover:bg-[#4F46E5] focus:ring-[#6366F1] shadow-sm',
    secondary: 'bg-[#EEF2FF] text-[#4338CA] hover:bg-[#E0E7FF] focus:ring-[#E0E7FF]',
    outline: 'border-2 border-[#4338CA] text-[#4338CA] hover:bg-[#EEF2FF] focus:ring-[#4338CA]',
    ghost: 'text-[#4338CA] hover:bg-[#EEF2FF]/50 hover:text-[#4F46E5]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    if (onClick) {
      onClick(e);
    }
  };
  return <motion.button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-333">
      {Icon && <Icon className="mr-2" size={size === 'sm' ? 16 : size === 'md' ? 20 : 24} data-id="element-334" />}
      {children}
    </motion.button>;
}